/*
 * Copyright © 2021 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as React from 'react';
import { HashRouter, Route } from 'react-router-dom';
import i18n, { currentLocale, setLocale } from './getText';
import ConfirmOrderPage from './pages/ConfirmOrderPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import SelectAddressPage from './pages/SelectAddressPage';
import { StoreService } from './store.service';
import '../index.css';

export const storeServiceInstance = new StoreService();

interface AppState {
  lang: string,
  isLandscape: boolean
}

export class App extends React.Component<any, AppState> {

  private w: number = window.innerWidth;
  private h: number = window.innerHeight;

  constructor(props) {
    super(props);

    this.resizeHandler = this.resizeHandler.bind(this);
    this.orientationHandler = this.orientationHandler.bind(this);
    this.isLandscape = this.isLandscape.bind(this);

    const userLang = localStorage.getItem("lang") || navigator.language || 'ar';
    setLocale(userLang.substr(0, 2));

    this.state = {
      lang: currentLocale,
      isLandscape: this.isLandscape()
    };
  }

  private resizeHandler() {
    const heightChanged = window.innerHeight !== this.h;
    const widthChanged = window.innerWidth !== this.w;
    const isLandscape = this.isLandscape();

    if (heightChanged && widthChanged) {
        // hide keyboard
        document.activeElement['blur']();
    }

    this.h = window.innerHeight;
    this.w = window.innerWidth;

    if (this.state.isLandscape !== isLandscape) {
      this.setState({isLandscape});
    }
  }

  private orientationHandler() {
    this.setState({isLandscape: this.isLandscape()})
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener("orientationchange", this.orientationHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
    window.removeEventListener('orientationchange', this.orientationHandler);
  }

  private isLandscape = () => {
    // this is experimental feature https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation
    const experimentalOrientation = (screen['orientation'] || {}).type;

    if(experimentalOrientation){
      return experimentalOrientation === 'landscape-primary' || experimentalOrientation === 'landscape-secondary'
    }

    // try to calculate orientation by screen size
    return window.innerWidth > window.innerHeight
  };

  private changeLocale = () => {
    const newLocale = currentLocale === 'AR' ? 'EN' : 'AR';
    setLocale(newLocale);
    localStorage.setItem('lang', newLocale);
    this.setState({lang: currentLocale});
  };

  public render() {
    const {lang, isLandscape} = this.state;

    return (
      <div className={lang === 'AR' ? 'content-rtl' : ''} ui-lang={lang.toLowerCase()}>
        {
          !isLandscape ? (
            <HashRouter>
                <React.Fragment>
                  <Route exact={true} path="/"
                         render={() => <OrderTrackingPage storeService={storeServiceInstance}/>}/>
                  <Route exact={true} path="/confirm-order"
                         render={() => <ConfirmOrderPage storeService={storeServiceInstance}/>}/>
                  <Route exact={true} path="/select-address"
                         render={() => <SelectAddressPage storeService={storeServiceInstance}/>}/>
                  <button
                    type="button"
                    onClick={this.changeLocale}
                    className="lang_btn lang_btn--bottom_right lang_btn--upper"/>
                </React.Fragment>
            </HashRouter>
          ) : (
            <div className="landscape_overlay">
              <div className="landscape_overlay-content">
                <img src="assets/deviceOrientation.png"
                     srcSet="assets/deviceOrientation@2x.png 2x, assets/deviceOrientation@3x.png 3x"
                     alt="deviceOrientation"/>
                <p className="landscape_overlay-heading">
                  {i18n.pgettext('Overlay', 'Landscape mode is not supported')}
                </p>
                <p>
                  {i18n.pgettext('Overlay', "To continue please change device\n orientation to portrait mode")}
                </p>
              </div>
            </div>
          )
        }
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/app/App.tsx